"use strict";
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Operation_1 = require("./Operation");
var Path_1 = require("../util/Path");
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!Node} snap
 * @constructor
 * @implements {Operation}
 */
var Overwrite = /** @class */ (function () {
 function Overwrite(source, path, snap) {
 this.source = source;
 this.path = path;
 this.snap = snap;
 /** @inheritDoc */
 this.type = Operation_1.OperationType.OVERWRITE;
 }
 Overwrite.prototype.operationForChild = function (childName) {
 if (this.path.isEmpty()) {
 return new Overwrite(this.source, Path_1.Path.Empty, this.snap.getImmediateChild(childName));
 }
 else {
 return new Overwrite(this.source, this.path.popFront(), this.snap);
 }
 };
 return Overwrite;
}());
exports.Overwrite = Overwrite;

//# sourceMappingURL=Overwrite.js.map



//////////////////
// WEBPACK FOOTER
// ../database/dist/cjs/src/core/operation/Overwrite.js
// module id = 46
// module chunks = 0